export default __webpack_public_path__ + "static/media/A6.8d27afc1.eps";